export class UnknownProductHttpHeaderError extends Error {}
